import {
    useMemo,
} from 'react'
import {
    SkyNetRouteConfigObject,
    useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import useRatesRoutes from 'app/SkyNetRoutes/hooks/useRatesRoutes'
import {
    RatesDomains,
} from 'app/enums/domain.enums'
import RateCards from './RateCards'

export default function Rates() {
    const Routes = useRatesRoutes()

    const routesConfig: SkyNetRouteConfigObject<RatesDomains> = useMemo(() => {
        return {
            [Routes.RateCards.route]: <RateCards />,
        }
    }, [Routes])

    return useSkyNetRoutes({
        routesConfig,
    })
}
